//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQModal from "../../../../../components/Generics/AQModal/AQModal.vue";
import AQButton from "../../../../../components/Generics/AQButton/AQButton.vue";

export default {
    components: {
        AQModal,
        AQButton
    },
    data() {
        return {
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            modal5: false,
            modal6: false,
            modal7: false,
            flicker1: true,
            modalInput: "",
            saved: "",
            headerActions: [
                {
                    label: "Delete"
                },
                {
                    label: "Archive"
                },
                {
                    label: "Test"
                }
            ],
            save: {
                label: "Save",
                disabled: false
            },
            primary: {
                label: "Primary",
                disabled: false
            },
            secondary: {
                label: "Secondary",
                disabled: true
            }
        };
    },
    methods: {
        actionsDlg1($event) {
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "primary":
                    alert("primary");
                    break;
                case "secondary":
                    alert("secondary");
                    break;
                case "close":
                case "escape":
                    this.modal1 = false;
                    this.flicker1 = true;
                    break;
                case "backdrop":
                    if (this.flicker1) {
                        this.flicker1 = false;
                    } else {
                        this.modal1 = false;
                        this.flicker1 = true;
                    }
                    break;
                default:
            }
        },
        actionsDlg2($event) {
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "primary":
                    alert("primary");
                    break;
                case "secondary":
                    alert("secondary");
                    break;
                case "close":
                case "escape":
                    this.modal2 = false;
                    this.flicker1 = true;
                    break;
                case "backdrop":
                    if (this.flicker1) {
                        this.flicker1 = false;
                    } else {
                        this.modal2 = false;
                        this.flicker1 = true;
                    }
                    break;
                default:
            }
        },
        actionsDlg3($event) {
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "primary":
                    alert("primary");
                    break;
                case "secondary":
                    alert("secondary");
                    break;
                case "close":
                case "escape":
                    this.modal3 = false;
                    this.flicker1 = true;
                    break;
                case "backdrop":
                    if (this.flicker1) {
                        this.flicker1 = false;
                    } else {
                        this.modal3 = false;
                        this.flicker1 = true;
                    }
                    break;
                case "Delete":
                    alert("Deleted");
                    break;
                case "Archive":
                    alert("Archived");
                    break;
                case "Test":
                    alert("Tested");
                    break;
                default:
            }
        },
        actionsDlg4($event) {
            switch ($event) {
                case "save":
                    this.saved = this.modalInput;
                    alert("save");
                    break;
                case "primary":
                    alert("primary");
                    break;
                case "secondary":
                    alert("secondary");
                    break;
                case "close":
                case "escape":
                    if (this.saved === this.modalInput) {
                        this.modal4 = false;
                        this.flicker1 = true;
                    } else {
                        alert("unsaved changes");
                    }
                    break;
                case "backdrop":
                    if (this.saved === this.modalInput) {
                        if (this.flicker1) {
                            this.flicker1 = false;
                        } else {
                            this.modal4 = false;
                            this.flicker1 = true;
                        }
                    }
                    break;
                default:
            }
        },
        actionsDlg5($event) {
            switch ($event) {
                case "save":
                    this.saved = this.modalInput;
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal5 = false;
                    this.flicker1 = true;
                    break;
                case "backdrop":
                    if (this.flicker1) {
                        this.flicker1 = false;
                    } else {
                        this.modal5 = false;
                        this.flicker1 = true;
                    }
                    break;
                default:
            }
        },
        actionsDlg6($event) {
            switch ($event) {
                case "save":
                    this.saved = this.modalInput;
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal6 = false;
                    this.flicker1 = true;
                    break;
                case "backdrop":
                    if (this.flicker1) {
                        this.flicker1 = false;
                    } else {
                        this.modal6 = false;
                        this.flicker1 = true;
                    }
                    break;
                default:
            }
        },
        actionsDlg7($event) {
            switch ($event) {
                case "save":
                    this.saved = this.modalInput;
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal7 = false;
                    this.flicker1 = true;
                    break;
                case "backdrop":
                    if (this.flicker1) {
                        this.flicker1 = false;
                    } else {
                        this.modal7 = false;
                        this.flicker1 = true;
                    }
                    break;
                default:
            }
        }
    }
};
